import React from 'react';
import LandingPageComponent from '../components/LandingPage';
import Header from '../components/Header';

const LandingPage = () => (
  <>
    <Header />
    <LandingPageComponent />
  </>
);

export default LandingPage;
